/*!
 * signature.js - signatures for javascript
 * Copyright (c) 2018, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcrypto
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var assert = require('bsert');

var _require = require('./util'),
    trimZeroes = _require.trimZeroes,
    countBits = _require.countBits,
    leftPad = _require.leftPad;
/**
 * Signature
 */


var Signature = /*#__PURE__*/function () {
  function Signature() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var r = arguments.length > 1 ? arguments[1] : undefined;
    var s = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Signature);

    this.r = leftPad(r, size);
    this.s = leftPad(s, size);
    this.param = 0;
  }

  _createClass(Signature, [{
    key: "setR",
    value: function setR(r, size) {
      this.r = leftPad(r, size);
      return this;
    }
  }, {
    key: "setS",
    value: function setS(s, size) {
      this.s = leftPad(s, size);
      return this;
    }
  }, {
    key: "isLowS",
    value: function isLowS(size, half) {
      assert(size >>> 0 === size);
      assert(Buffer.isBuffer(half));
      assert(half.length === size);
      if (this.s.length !== size) return false;
      if (countBits(this.s) === 0) return false;
      return this.s.compare(half) <= 0;
    }
  }, {
    key: "encode",
    value: function encode(size) {
      assert(size >>> 0 === size);
      assert(size < 0x7d);
      assert(this.r.length === size);
      assert(this.s.length === size);
      var raw = Buffer.allocUnsafe(size * 2);
      this.r.copy(raw, 0);
      this.s.copy(raw, size);
      return raw;
    }
  }, {
    key: "decode",
    value: function decode(data, size) {
      assert(Buffer.isBuffer(data));
      assert(size >>> 0 === size);
      assert(data.length === size * 2);
      this.r = data.slice(0, size);
      this.s = data.slice(size, size * 2);
      return this;
    }
  }, {
    key: "toDER",
    value: function toDER(size) {
      assert(size >>> 0 === size);
      assert(size < 0x7d);
      assert(this.r.length === size);
      assert(this.s.length === size);
      var r = encodeInt(this.r);
      var s = encodeInt(this.s);
      var seq = 2 + r.length + 2 + s.length;
      var wide = seq >= 0x80 ? 1 : 0;
      var len = 2 + wide + seq;
      var buf = Buffer.allocUnsafe(len);
      var p = 0;
      buf[p++] = 0x30;
      if (wide) buf[p++] = 0x81;
      buf[p++] = seq;
      buf[p++] = 0x02;
      buf[p++] = r.length;
      p += r.copy(buf, p);
      buf[p++] = 0x02;
      buf[p++] = s.length;
      p += s.copy(buf, p);
      assert(p === len);
      return buf;
    }
  }, {
    key: "fromDER",
    value: function fromDER(data, size) {
      assert(Buffer.isBuffer(data));
      assert(size >>> 0 === size);
      var len = 0;
      var pos = 0;
      var rlen = 0;
      var slen = 0;
      var r = null;
      var s = null; // Sequence tag byte.

      assert(pos + 1 <= data.length);
      assert(data[pos] === 0x30);
      pos += 1; // Sequence length bytes.

      assert(pos + 1 <= data.length);
      len = data[pos];
      pos += 1;

      if (len & 0x80) {
        len -= 0x80;
        assert(pos + len <= data.length);
        pos += len;
      } // Integer tag byte for R.


      assert(pos + 1 <= data.length);
      assert(data[pos] === 0x02);
      pos += 1; // Integer length for R.

      assert(pos + 1 <= data.length);
      len = data[pos];
      pos += 1;

      if (len & 0x80) {
        len -= 0x80;
        assert(pos + len <= data.length);

        while (len > 0 && data[pos] === 0x00) {
          len -= 1;
          pos += 1;
        }

        assert(len <= 6);

        while (len > 0) {
          rlen *= 0x100;
          rlen += data[pos];
          len -= 1;
          pos += 1;
        }
      } else {
        rlen = len;
      } // Ignore leading zeroes in R.


      assert(pos + rlen <= data.length);

      while (rlen > 0 && data[pos] === 0x00) {
        rlen -= 1;
        pos += 1;
      }

      if (rlen > size) r = Buffer.alloc(size, 0x00);else r = data.slice(pos, pos + rlen);
      pos += rlen; // Integer tag byte for S.

      assert(pos + 1 <= data.length);
      assert(data[pos] === 0x02);
      pos += 1; // Integer length for S.

      assert(pos + 1 <= data.length);
      len = data[pos];
      pos += 1;

      if (len & 0x80) {
        len -= 0x80;
        assert(pos + len <= data.length);

        while (len > 0 && data[pos] === 0x00) {
          len -= 1;
          pos += 1;
        }

        assert(len <= 6);

        while (len > 0) {
          slen *= 0x100;
          slen += data[pos];
          len -= 1;
          pos += 1;
        }
      } else {
        slen = len;
      } // Ignore leading zeroes in S.


      assert(pos + slen <= data.length);

      while (slen > 0 && data[pos] === 0x00) {
        slen -= 1;
        pos += 1;
      }

      if (slen > size) s = Buffer.alloc(size, 0x00);else s = data.slice(pos, pos + slen);
      pos += slen;
      this.r = leftPad(r, size);
      this.s = leftPad(s, size);
      return this;
    }
  }], [{
    key: "decode",
    value: function decode(data, size) {
      return new this().decode(data, size);
    }
  }, {
    key: "fromDER",
    value: function fromDER(data, size) {
      return new this().fromDER(data, size);
    }
  }, {
    key: "toRS",
    value: function toRS(raw, size) {
      var sig = Signature.fromDER(raw, size);
      return sig.encode(size);
    }
  }, {
    key: "toDER",
    value: function toDER(raw, size) {
      var sig = Signature.decode(raw, size);
      return sig.toDER(size);
    }
  }, {
    key: "normalize",
    value: function normalize(raw, size) {
      var sig = Signature.fromDER(raw, size);
      return sig.toDER(size);
    }
  }, {
    key: "isLowDER",
    value: function isLowDER(raw, size, half) {
      assert(Buffer.isBuffer(raw));
      assert(size >>> 0 === size);
      assert(Buffer.isBuffer(half));
      var sig;

      try {
        sig = Signature.fromDER(raw, size);
      } catch (e) {
        return false;
      }

      return sig.isLowS(size, half);
    }
  }, {
    key: "isLowS",
    value: function isLowS(raw, size, half) {
      assert(Buffer.isBuffer(raw));
      assert(size >>> 0 === size);
      assert(Buffer.isBuffer(half));
      var sig;

      try {
        sig = Signature.decode(raw, size);
      } catch (e) {
        return false;
      }

      return sig.isLowS(size, half);
    }
  }]);

  return Signature;
}();
/*
 * Helpers
 */


function encodeInt(buf) {
  var val = trimZeroes(buf);

  if (val[0] & 0x80) {
    var out = Buffer.allocUnsafe(1 + val.length);
    out[0] = 0x00;
    val.copy(out, 1);
    return out;
  }

  return val;
}
/*
 * Expose
 */


module.exports = Signature;